import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@airbus/components-react';
import StyledTooltip from './StyledTooltip'; // Adjust path if needed
import style from './grid/SetColumnConfig.module.css';

interface Props {
  formattedValue: string;
  type: string;
  getIcon: (type: string) => React.ReactNode;
  iconVisible?: boolean;
  error?: { msg: string };
  value?: string;
}

const CellWithTooltipCheck: React.FC<Props> = ({
  formattedValue,
  type,
  getIcon,
  iconVisible = false,
  error,
  value,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [overflow, setOverflow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [formattedValue]);

  const content = (
    <div className={style.cell}>
      <div ref={ref} className={style.cell_content}>
        {formattedValue}
      </div>
      {iconVisible && getIcon(type)}
    </div>
  );

  if (error?.msg) {
    return (
      <StyledTooltip title={error.msg}>
        <div className={`${style.render_edit_cell} Mui-error`}>
          {content}
        </div>
      </StyledTooltip>
    );
  }

  const isValidTooltip = value && formattedValue?.length > 18;

  if (
    (type === 'textarea' && (overflow || isValidTooltip)) ||
    (type === 'string' && (overflow || isValidTooltip)) ||
    (type === 'singleSelect' && (overflow || isValidTooltip))
  ) {
    return (
      <div className={style.tootip_outer}>
        <Tooltip placement="bottom" label={formattedValue}>
          {content}
        </Tooltip>
      </div>
    );
  }

  return content;
};

export default CellWithTooltipCheck;
